export default "__VITE_ASSET__Bze2IbUE__"